import React, { useState } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE;

const Automod = () => {
    const [words, setWords] = useState('');
    const [wordsList, setWordsList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleLoadWords = async () => {
        try {
            const token = localStorage.getItem('discord_token');
            const response = await axios.get(`${API_BASE}/api/automod/words`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.data.success) {
                setWordsList(response.data.words || []);
            }
        } catch (err) {
            console.error('Fehler beim Laden der Wörter:', err);
        }
    };

    React.useEffect(() => {
        handleLoadWords();
    }, []);

    const handleAddWords = async (e) => {
        e.preventDefault();
        const newWords = words.split('\n').map(w => w.trim()).filter(w => w.length > 0);
        if (newWords.length === 0) {
            setError('Bitte mindestens ein Wort eingeben.');
            return;
        }

        setIsLoading(true);
        setError(null);
        setSuccess(false);
        try {
            const token = localStorage.getItem('discord_token');
            const response = await axios.post(`${API_BASE}/api/automod/words`, {
                words: newWords
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.data.success) {
                setSuccess(true);
                setWords('');
                setWordsList([...wordsList, ...newWords]);
            } else {
                throw new Error(response.data.error || 'Fehler beim Hinzufügen der Wörter');
            }
        } catch (err) {
            setError(err.response?.data?.error || err.message || 'Fehler beim Hinzufügen der Wörter');
        } finally {
            setIsLoading(false);
        }
    };

    const handleRemoveWord = async (word) => {
        try {
            const token = localStorage.getItem('discord_token');
            const response = await axios.delete(`${API_BASE}/api/automod/words/${encodeURIComponent(word)}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.data.success) {
                setWordsList(wordsList.filter(w => w !== word));
            } else {
                throw new Error(response.data.error || 'Fehler beim Entfernen');
            }
        } catch (err) {
            setError(err.response?.data?.error || err.message || 'Fehler beim Entfernen');
        }
    };

    return (
        <div className="dashboard-main">
            <div className="hero-panel">
                <div>
                    <h2 style={{ margin: 0, fontSize: '1.8rem' }}>🛡️ Automod</h2>
                    <p className="muted small">Wortfilter für Sicherheit und Inhaltskontrolle</p>
                </div>
            </div>

            <div className="grid">
                <div className="card">
                    <div className="card-header">
                        <h4>Wörter hinzufügen</h4>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleAddWords}>
                            <div className="form-group">
                                <label htmlFor="automod-words">Wörter (jeweils eine Zeile)</label>
                                <textarea
                                    id="automod-words"
                                    placeholder="Beleidigung1&#10;Beleidigung2&#10;..."
                                    value={words}
                                    onChange={(e) => setWords(e.target.value)}
                                    disabled={isLoading}
                                    rows={6}
                                    className="form-textarea"
                                />
                                <small className="form-help">
                                    Geben Sie Wörter ein, die automatisch gefiltert werden sollen. Ein Wort pro Zeile.
                                </small>
                            </div>

                            {error && (
                                <div className="alert alert-error">
                                    <span className="alert-icon">⚠️</span>
                                    <span>{error}</span>
                                </div>
                            )}

                            {success && (
                                <div className="alert alert-success">
                                    <span className="alert-icon">✅</span>
                                    <span>Wörter erfolgreich hinzugefügt!</span>
                                </div>
                            )}

                            <div className="form-actions">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={isLoading || !words.trim()}
                                >
                                    {isLoading ? (
                                        <>
                                            <span className="spinner-sm"></span>
                                            Wird hinzugefügt...
                                        </>
                                    ) : (
                                        'Hinzufügen'
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="card">
                    <div className="card-header">
                        <h4>Aktuelle Filterliste ({wordsList.length} Wörter)</h4>
                    </div>
                    <div className="card-body">
                        {wordsList.length === 0 ? (
                            <p className="muted">Keine Wörter in der Filterliste.</p>
                        ) : (
                            <div className="list">
                                {wordsList.map((word, index) => (
                                    <div key={index} className="list-item">
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                            <strong>{word}</strong>
                                            <button
                                                className="btn btn-danger btn-sm"
                                                onClick={() => handleRemoveWord(word)}
                                            >
                                                Entfernen
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Automod;
